import React, { useEffect, useState } from "react";
import "./Header.css";

const Header = () => {
  // Theme state (light / dark)
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem("theme");
    if (saved) return saved;
    const prefersDark =
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches;
    return prefersDark ? "dark" : "light";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () =>
    setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <header className="app-header">
      {/* Theme toggle */}
      <button
        className="themeToggle"
        onClick={toggleTheme}
        aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
        title={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      >
        {theme === "dark" ? "☀️ Light" : "🌙 Dark"}
      </button>

      <div className="header-content">
        <h1 className="app-title">
          <span className="title-main">JSON</span>{" "}
          <span className="title-accent">PathFinder</span>
        </h1>
        <p className="app-subtitle">
          Find JSON Paths &amp; Generate Velocity / Python Code
        </p>
        <span className="accent-underline" aria-hidden="true" />
      </div>
    </header>
  );
};

export default Header;
